enum CustomSounds {
  INCOMING = 'https://storagenator-prod-public.s3.us-west-2.amazonaws.com/internal/sounds/custom/SFX_Succesful_Transfer_1.wav',
  OUTGOING = 'https://storagenator-prod-public.s3.us-west-2.amazonaws.com/internal/sounds/custom/SFX_Dial_5.wav',
  DISCONNECT = 'https://storagenator-prod-public.s3.us-west-2.amazonaws.com/internal/sounds/custom/SFX_Call_Ended_1.wav',
}

export default CustomSounds;
